import { actionTypes } from '../../../types';

export const optUGCCampaign = (payload, callback) => ({
    type: actionTypes.OPT_UGC_CAMPAIGN_REQUEST,
    payload,
    callback
});

export const optUGCCampaignSuccess = (payload) => ({
    type: actionTypes.OPT_UGC_CAMPAIGN_SUCCESS,
    payload,
});

export const optUGCCampaignFailure = (payload) => ({
    type: actionTypes.OPT_UGC_CAMPAIGN_FAILURE,
    payload,
});

export const optUGCCampaignReset = () => ({
    type: actionTypes.OPT_UGC_CAMPAIGN_RESET,
});

export const optUGCCampaignResetAll = () => ({
    type: actionTypes.OPT_UGC_CAMPAIGN_RESET_ALL,
});
